import { gql, useMutation } from '@apollo/client'

import agentClient from '@/lib/apollo/client/agent'
import type { WrappedMutation } from '@/lib/apollo/types'

const deleteDocumentMutation = gql`
  mutation deleteDocument(
    $customerId: String!
    $subjectId: String!
    $userId: String!
    $documentId: String!
  ) {
    deleteDocument(
      customerId: $customerId
      subjectId: $subjectId
      userId: $userId
      documentId: $documentId
    )
  }
`

export type MutationVars = {
  customerId: string
  subjectId: string
  userId: string
  documentId: string
}

export type DeleteDocumentData = {
  deleteDocument: string | unknown
}

export const useDeleteDocumentMutation: WrappedMutation<
  DeleteDocumentData,
  MutationVars
> = () =>
  useMutation<DeleteDocumentData, MutationVars>(deleteDocumentMutation, {
    client: agentClient,
  })
